import React, { Component } from 'react';
import CodeCopy from './copy';
import "code-highlight/lib/style.css";
import "highlight.js/styles/googlecode.css";
import axios from 'axios';
import ResultNotice from './notice';
import loaderImg from '../../static/images/rabbit-loading.gif';
import WrapperCode from './wrapperCode';

export default class Code extends Component {
  static get STATUS_INIT() {return 'init';}
  static get STATUS_LOADING() {return 'loading';}
  static get STATUS_DONE() {return 'done';}
  constructor(props) {
    super(props);
    this.state = {
      status: Code.STATUS_INIT,
      ampHtml: '',
      cnt: 0
    };
  }

  componentDidMount() {
    let self = this;
    this.setState({
      status: Code.STATUS_LOADING,
      cnt: ++self.state.cnt
    }, () => {
      axios.get(this.props.ampUrl)
        .then(res => {
          self.setState({
            status: Code.STATUS_DONE,
            ampHtml: res.data,
            cnt: ++self.state.cnt
          });
        }).catch(e => {
          self.setState({
            status: Code.STATUS_DONE,
            ampHtml: 'unable to load data',
            cnt: ++self.state.cnt
          });
        });
    });
  }

  bytesToSize(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (!bytes) {
      return '';
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return Math.round(bytes / Math.pow(1024, i), 2) + '' + sizes[i];
  }

  render() {
    let {T} = this.props
    const isNotice = !!(this.props.noticeList && this.props.noticeList.length);
    return (
        <div className="result-box">
            <div className={'amp-result' + (isNotice ? '': ' full')}>
                <div className="title">
                    <div className="name-size">
                        <span>AMP HTML</span>
                        <i>{this.bytesToSize(this.state.ampHtml && this.state.ampHtml.length)}</i>
                    </div>
                    <CodeCopy text={this.state.ampHtml} T={T}/>
                </div>
                <div className="code-result" key={'code-id-' + this.state.cnt}>
                  {!!~[Code.STATUS_LOADING].indexOf(this.state.status) && <img src={loaderImg} className="loading" alt="loading" />}
                  {!!~[Code.STATUS_DONE].indexOf(this.state.status) && <WrapperCode ampHtml={this.state.ampHtml} />}
                </div>
            </div>
            {isNotice && <ResultNotice list={this.props.noticeList} T={T}/>}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/result/code.js